import "./InformationBlock.css";
import { useState, useEffect, useRef } from "react";
import { getApiErrorMessage, updateContact } from "../../../../api/api";
import Modal from "../../../../components/elements/Modal/Modal";
import Icon from "../../../../components/elements/Icons/Icon";

export default function InformationBlock(props) {
    const { type, id, title: propTitle, post: propPost, description: propDescription, avatar: propAvatar } = props;
    
    // Состояния
    const [isAdmin, setIsAdmin] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState(propTitle || '');
    const [post, setPost] = useState(propPost || '');
    const [description, setDescription] = useState(propDescription || '');
    const [avatarImg, setAvatarImg] = useState(propAvatar || null);
    
    const fileInputRef = useRef(null);

    // Проверка админа
    useEffect(() => {
        const admin = localStorage.getItem('isAdmin') === 'true';
        setIsAdmin(admin);
    }, []);

    // Обработчики
    const onTitleChange = (e) => setTitle(e.target.value);
    const onPostChange = (e) => setPost(e.target.value);
    const onDescriptionChange = (e) => setDescription(e.target.value);

    const onFileSelect = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
        if (!allowedTypes.includes(file.type)) {
            alert('Dozwolone formaty: JPG, PNG, WEBP i GIF.');
            e.target.value = '';
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            alert('Awatar może mieć maksymalnie 10 MB.');
            e.target.value = '';
            return;
        }
        
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => setAvatarImg(reader.result);
    };

    const removeAvatar = () => setAvatarImg(null);

    const openEditor = () => setIsEditing(true);
    const closeEditor = () => setIsEditing(false);

    const saveData = async () => {
        setLoading(true);
        try {
            const payload = {
                id: id,
                title: title,
                post: post,
                description: description,
                avatar: avatarImg,
            };

            const response = await updateContact(payload);
            
            if (response.success) {
                closeEditor();
                window.location.reload();
            } else {
                alert('Błąd: ' + (response.error || 'Nieznany błąd'));
            }
        } catch (error) {
            console.error(error);
            alert(getApiErrorMessage(error, 'Błąd zapisu'));
        } finally {
            setLoading(false);
        }
    };

    const blockContent = (
        <div className={`information-container-block information-container-block-${type}`}>
            {isAdmin && (
                <button className="information-edit-btn" onClick={openEditor}>
                    <Icon name="pen" />
                </button>
            )}
            
            <img 
                className={`information-avatar information-avatar-${type}`} 
                src={avatarImg} 
                alt="" 
            />
            
            <div className={`information-right-block information-right-block-${type}`}>
                <h2 className={`information-block-title information-block-title-${type}`}>
                    {title}
                </h2>
                {type === "small" && <div className="information-block-line"></div>}
                <h6 className={`information-block-post information-block-post-${type}`}>
                    {post}
                </h6>
                {type === "big" && <div className="information-block-line"></div>}
                <p className={`information-block-description information-block-description-${type}`}>
                    {description}
                </p>
            </div>
        </div>
    );

    // Рендер модалки
    const modalContent = isEditing ? (
        <Modal isOpen={isEditing} onClose={closeEditor}>
            <div className="information-modal">
                <h2 className="information-modal-title">Edycja bloku</h2>
                
                <div className="information-modal-field">
                    <label>Awatar</label>
                    <div className="information-avatar-upload">
                        <img 
                            src={avatarImg} 
                            alt="Podgląd" 
                            className="information-avatar-preview"
                        />
                        <button 
                            className="information-upload-btn"
                            onClick={() => fileInputRef.current?.click()}
                        >
                            Załaduj obraz
                        </button>
                        <input 
                            type="file" 
                            ref={fileInputRef}
                            onChange={onFileSelect}
                            accept="image/*"
                            style={{ display: 'none' }}
                        />
                        {avatarImg && (
                            <button 
                                className="information-remove-avatar"
                                onClick={removeAvatar}
                            >
                                Usuń
                            </button>
                        )}
                    </div>
                </div>

                <div className="information-modal-field">
                    <label>Tytuł</label>
                    <input
                        type="text"
                        value={title}
                        onChange={onTitleChange}
                        className="information-modal-input"
                        placeholder="Wpisz tytuł"
                    />
                </div>

                <div className="information-modal-field">
                    <label>Stanowisko</label>
                    <input
                        type="text"
                        value={post}
                        onChange={onPostChange}
                        className="information-modal-input"
                        placeholder="Wpisz stanowisko"
                    />
                </div>

                {type === "big" && (
                    <div className="information-modal-field">
                        <label>Opis</label>
                        <textarea
                            value={description}
                            onChange={onDescriptionChange}
                            className="information-modal-textarea"
                            rows="6"
                            placeholder="Wpisz opis..."
                        />
                    </div>
                )}

                <div className="information-modal-actions">
                    <button 
                        className="information-modal-btn information-modal-btn-cancel"
                        onClick={closeEditor}
                        disabled={loading}
                    >
                        Anuluj
                    </button>
                    <button 
                        className="information-modal-btn information-modal-btn-save"
                        onClick={saveData}
                        disabled={loading}
                    >
                        {loading ? 'Zapisywanie...' : 'Zapisz'}
                    </button>
                </div>
            </div>
        </Modal>
    ) : null;

    return (
        <>
            {blockContent}
            {modalContent}
        </>
    );
}
